export const REQUEST_SHIPMENT_DATA_BY_ACCOUNT_NUMBER = "REQUEST_SHIPMENT_DATA_BY_ACCOUNT_NUMBER";
export const RECEIVE_SHIPMENT_DATA_BY_ACCOUNT_NUMBER = "RECEIVE_SHIPMENT_DATA_BY_ACCOUNT_NUMBER";
export const SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR= "SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR";
export const RESET_SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR = 'RESET_SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR';

export const requestShipmentDataByAccountNumber = (payload) => ({
  type: REQUEST_SHIPMENT_DATA_BY_ACCOUNT_NUMBER,
  payload
});

export const serviceErrorShipmentByAccountNumber = payload => ({type: SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR, payload: payload});

export const resetServiceErrorShipmentByAccountNumber = () => ({type: RESET_SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR});


// WEBPACK FOOTER //
// ./src/actions/shipmentDataByAccountNumberActions.js